(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["qfp-customize-banners"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-qfp-customize-banners]');
    if (!root || root.dataset.qfpCbReady) return;
    root.dataset.qfpCbReady = '1';

    var grid = root.querySelector('.qfp-cb__grid');
    var banners = {
      size: root.querySelector('[data-qfp-cb="size"]'),
      colors: root.querySelector('[data-qfp-cb="colors"]')
    };
    /* Looked up at click/sync time (never cached) so the banners keep working
       after the theme re-renders the product section (variant change, editor). */
    var triggers = {
      size: function () { return document.getElementById('qfp-customize-btn'); },
      colors: function () { return document.querySelector('#qfp-cc-root [data-qfp-cc="open"]'); }
    };
    var pendingFocus = null; /* banner that opened the current dialog */

    function isUsable(el) {
      return !!(el && !el.hidden && !el.disabled && el.getClientRects().length);
    }

    function sync() {
      var count = 0;
      Object.keys(banners).forEach(function (key) {
        var banner = banners[key];
        if (!banner) return;
        banner.hidden = !isUsable(triggers[key]());
        if (!banner.hidden) count++;
      });
      grid.setAttribute('data-count', String(count));
      root.hidden = count === 0;
    }

    Object.keys(banners).forEach(function (key) {
      var banner = banners[key];
      if (!banner) return;
      banner.addEventListener('click', function (event) {
        event.preventDefault();
        var trigger = triggers[key]();
        if (!isUsable(trigger)) { sync(); return; }
        pendingFocus = banner;
        trigger.click(); /* exactly one launch per click, via the original control */
      });
    });

    /* Return focus to the initiating banner when its dialog closes. */
    function watchDialog(key, el, isClosed, attrs) {
      if (!el || !('MutationObserver' in window)) return;
      new MutationObserver(function () {
        if (pendingFocus === banners[key] && isClosed(el)) {
          pendingFocus = null;
          if (!banners[key].hidden) banners[key].focus({ preventScroll: true });
        }
      }).observe(el, { attributes: true, attributeFilter: attrs });
    }
    function watchDialogs() {
      watchDialog('size', document.getElementById('qfp-modal-overlay'),
        function (el) { return el.style.display === 'none'; }, ['style']);
      watchDialog('colors', document.querySelector('[data-qfp-cc="overlay"]'),
        function (el) { return !el.classList.contains('qfp-cc-on'); }, ['class']);
    }

    /* The colors control is revealed asynchronously; follow its hidden attribute. */
    var ccRoot = document.getElementById('qfp-cc-root');
    if (ccRoot && 'MutationObserver' in window) {
      new MutationObserver(sync).observe(ccRoot, { attributes: true, subtree: true, attributeFilter: ['hidden'] });
    }
    document.addEventListener('shopify:section:load', function () { sync(); watchDialogs(); });
    window.addEventListener('load', sync);
    sync();
    watchDialogs();
    /* Belt and braces for the deferred recolor bundle on slow connections. */
    [500, 1500, 4000].forEach(function (ms) { setTimeout(sync, ms); });
  })();

  } catch(e) { console.error(e); }
})();
})();
